import { cva, VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'font-semibold shadow-xs inline-flex justify-center items-center',
  {
    variants: {
      variant: {
        primary:
          'bg-primary-600 disabled:bg-gray-100 disabled:text-gray-600 text-white hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
        outline:
          'bg-white text-gray-900 disabled:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed ring-1 ring-inset ring-gray-200 hover:bg-gray-50',
        destructive: 'bg-red-600 text-white hover:bg-destructive-500',
        soft: 'bg-primary-50 text-primary-600 hover:bg-primary-100',
        ghost: 'text-gray-900 hover:bg-gray-50',
        transparent:
          'bg-transparent text-gray-900 hover:bg-gray-50 border-none',
      },
      size: {
        xs: 'rounded text-xs px-2 py-1',
        sm: 'rounded text-sm px-2 py-1',
        md: 'rounded-md px-2.5 py-1.5 text-sm',
        lg: 'rounded-md px-3 py-2 text-sm',
        xl: 'rounded-md text-sm px-3.5 py-2.5',
        square: 'rounded-md h-8 w-8 ',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
)

export type ButtonVariant = VariantProps<typeof buttonVariants>
